import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import { CfarPostBookingConfirmAndBook } from "./component";
import {
  deletePaymentMethod,
  fetchTravelWalletSummary,
  fetchProductToEarn,
  listPaymentMethods,
  resetPaymentCardSelectedAccounts,
  setCreditToApply,
  setOfferToApply,
  setSelectedPaymentMethodId,
  setSelectedRewardsPaymentTotal,
  setTravelWalletCredit,
  setTravelWalletOffers,
  verifyPaymentMethod,
} from "../../../book/actions/actions";
import {
  getRewardsAccounts,
  getSelectedAccountReferenceId,
  getUserIsPrimaryCardHolder,
} from "../../../rewards/reducer";
import {
  getApplicableCredit,
  getBestOfferOverall,
  getCreditToApply,
  getDeletePaymentMethodCallState,
  getFetchTravelWalletSummaryCallState,
  getHasError,
  getIsCreditCardPaymentRequired,
  getIsStackedTravelWalletPaymentOnly,
  getIsTravelWalletOfferPaymentOnly,
  getListPaymentMethodsCallState,
  getMaxApplicableTravelWalletCreditAmount,
  getOffers,
  getOfferToApply,
  getPaymentMethods,
  getRewardsPaymentAccount,
  getRewardsPaymentAccountReferenceId,
  getRewardsPaymentInFiatCurrency,
  getRewardsPaymentInRewardsCurrency,
  getSelectedPaymentMethodId,
  getTravelWalletCreditToApplyAmount,
  getVerifyPaymentMethodCallState,
  rewardsAccountMinimumRequirementStateSelector,
} from "../../../book/reducer";
import { fetchRewardsAccounts } from "../../../rewards/actions/actions";
import { actions } from "../../../book/actions";
import { getAllowRewardsWithPolicy } from "../../../shop/reducer";
import {
  getCreditBreakdown,
  getTravelCreditsHistoryTransaction,
  getPartialHistoryValidFromTime,
} from "../../../travel-wallet/reducer";
import { cfarPostBookingOfferSelector, cfarPostBookingOfferStateSelector, cfarPostBookingFetchOfferRequestSelector, cfarPostBookingPurchaseCallStateSelector, cfarPostBookingPurchaseResponseSelector } from "../../reducer/selectors/postBooking";
import { fetchCfarPostBookingOffer, purchaseCfarPostBookingOffer } from "../../actions/actions";
import { isPostBookingCfarEnabledSelector } from "../../reducer/selectors";

const mapStateToProps = (state: IStoreState) => ({
  cfarOffer: cfarPostBookingOfferSelector(state),
  cfarPostBookingOfferState: cfarPostBookingOfferStateSelector(state),
  cfarPostBookingFetchOfferRequest: cfarPostBookingFetchOfferRequestSelector(state),
  cfarPostBookingPurchaseCallState: cfarPostBookingPurchaseCallStateSelector(state),
  cfarPostBookingPurchaseResponse: cfarPostBookingPurchaseResponseSelector(state),
  isPostBookingCfarEnabled: isPostBookingCfarEnabledSelector(state),
  paymentMethods: getPaymentMethods(state),
  rewardsAccounts: getRewardsAccounts(state),
  selectedAccountReferenceId: getSelectedAccountReferenceId(state),
  selectedPaymentMethodId: getSelectedPaymentMethodId(state) ?? "",
  listPaymentMethodCallState: getListPaymentMethodsCallState(state),
  verifyPaymentMethodCallState: getVerifyPaymentMethodCallState(state),
  deletePaymentMethodCallState: getDeletePaymentMethodCallState(state),
  selectedRewardsPaymentAccount: getRewardsPaymentAccount(state),
  selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
  rewardsPaymentInFiatCurrency: getRewardsPaymentInFiatCurrency(state),
  rewardsPaymentInRewardsCurrency: getRewardsPaymentInRewardsCurrency(state),
  rewardsAccountMinimumRequirementState:
    rewardsAccountMinimumRequirementStateSelector(state),
  isCreditCardPaymentRequired: getIsCreditCardPaymentRequired(state),
  userIsPrimary: getUserIsPrimaryCardHolder(state),
  canRedeemRewards: getAllowRewardsWithPolicy(state),
  isTravelWalletOfferPaymentOnly: getIsTravelWalletOfferPaymentOnly(state),
  isStackedTravelWalletPaymentOnly: getIsStackedTravelWalletPaymentOnly(state),
  hasError: getHasError(state),
  offers: getOffers(state),
  offerToApply: getOfferToApply(state),
  fetchApplicableTravelWalletItemsCallState:
    getFetchTravelWalletSummaryCallState(state),
  credits: getApplicableCredit(state),
  creditBreakdown: getCreditBreakdown(state),
  creditsToApply: getCreditToApply(state),
  creditsHistoryTransaction: getTravelCreditsHistoryTransaction(state),
  partialHistoryValidFromTime: getPartialHistoryValidFromTime(state),
  bestOverallOffer: getBestOfferOverall(state),
  maxApplicableTravelWalletCredit:
    getMaxApplicableTravelWalletCreditAmount(state),
  getTravelWalletCreditToApplyAmount: getTravelWalletCreditToApplyAmount(state),
  creditToApply: getCreditToApply(state),
});

const mapDispatchToProps = {
  listPaymentMethods,
  verifyPaymentMethod,
  deletePaymentMethod,
  setSelectedPaymentMethodId,
  fetchRewardsAccounts,
  fetchProductToEarn,
  fetchTravelWalletSummary,
  setTravelWalletCredit,
  setTravelWalletOffers,
  setOfferToApply,
  resetPaymentCardSelectedAccounts,
  setSelectedRewardsPaymentTotal,
  setCreditToApply,
  setSelectedRewardsAccountId: actions.setSelectedRewardsAccountReferenceId,
  setRewardsPaymentAmount: actions.setSelectedRewardsPaymentTotal,
  setPaymentMethod: actions.setPaymentMethod,
  setRewardsConversionFailed: actions.setRewardsConversionFailed,
  setEarnValue: actions.setEarnValue,
  setQuotedRewardsTotal: actions.setQuotedRewardsTotal,
  fetchCfarPostBookingOffer,
  purchaseCfarPostBookingOffer,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type CfarPostBookingConfirmAndBookConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedCfarPostBookingConfirmAndBook = withRouter(
  connector(CfarPostBookingConfirmAndBook)
);
